<span class="wrapper">
  <span class="icon" [class]="icon()"></span>
</span>
